import React, {useCallback, useEffect, useRef} from 'react';

// declare global {
//     interface Window {
//         turnstile: any;
//         turnstileCallback: (token: string) => void;
//         onloadTurnstileCallback: () => void;
//     }
// }
function TurnstileCaptchaRenderer({
    onChange
                                  }) {
    const iframe = useRef<HTMLIFrameElement | null>(null);
    useEffect(() => {
        window.addEventListener("message", (event) => {
            if (event.data?.type === "turnstile-resize") {
                // const iframe = document.getElementById("turnstileFrame");
                iframe.current!.style.width = event.data.width + "px";
                iframe.current!.style.height = event.data.height + "px";
            }

            if (event.data?.type === "turnstile-success") {
                onChange({
                        type:'turnstile',
                        value: event.data.token
                    })
                // console.log("Turnstile token:", event.data.token);
            }
        });
    }, []);

    return <iframe ref={iframe} src={"https://creatives.goaffpro.com/7/vtbqpkty-turnstile-iframe.html"} style={{
        border: 'none',
        width: '100%',
        height: '100px',
    }} ></iframe>
}

// function TurnstileCaptchaRenderer({onChange}) {
//     const render = useCallback(()=>{
//         if(window.turnstile) {
//             window.turnstile.render('#cf-turnstile', {
//                 sitekey: '0x4AAAAAAALRXKa8yBsKwSxF',
//                 theme: "light",
//                 callback: function(token) {
//                     onChange({
//                         target:{
//                             value:{
//                                 type:'turnstile',
//                                 value: token,
//
//                             }
//                         }
//                     })
//                 },
//             });
//             window.turnstileCallback = function (token) {
//                 onChange({
//                     target:{
//                         value:{
//                             type:'turnstile',
//                             value: token,
//                         }
//                     },
//                 });
//             }
//         }
//     },[onChange])
//
//     useEffect(() => {
//         const d = document.createElement('script');
//         d.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=onloadTurnstileCallback";
//         d.onload = render;
//         document.body.appendChild(d);
//
//         return ()=>{
//             document.body.removeChild(d);
//         }
//     }, []);
//     return (
//         <>
//             <div id="cf-turnstile"
//                  data-theme={"light"}
//                  data-sitekey="0x4AAAAAAALRXKa8yBsKwSxF"
//                  data-callback="turnstileCallback"></div>
//         </>
//     );
// }

export default TurnstileCaptchaRenderer;
